import store from "@/store";
import { ProjectDataModel, ProjectModel } from "@/common/classes/models";
import StorageService from "./storage.service";

export function saveLastLocalProject() {
    const {product,channels,projectData} = store.state;
    const projectModel = new ProjectModel(product,channels,projectData as ProjectDataModel);
    const { LAST_LOCAL_PROJECT } = StorageService.getStorageItems();
    LAST_LOCAL_PROJECT.setData(projectModel);
}